module.exports = __webpack_public_path__ + "img/editLatexWhite.dd23996b.svg";